if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        // Store product variants from dataset if available
        this.variantsData = this.dataset.variants ? JSON.parse(this.dataset.variants) : null;
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll('select option[selected], fieldset input:checked')
        ).map(({ dataset }) => dataset.optionValueId);
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT'
          ? target.selectedOptions[0]
          : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          
          // Auto-select first available sub-option
          this.ensureValidCombination(target);

          const itemId = String(target.name || '').trim();
          const itemVariant =  String(target.value || '').trim();
          gtag('event', 'select_item', {
            items: [{
              item_id: itemId,
              item_name: itemVariant,
              item_variant: itemVariant,
            }],
          });


          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      ensureValidCombination(changedTarget) {
        if (!this.variantsData) return; // need variant info
        const allSelectors = Array.from(this.querySelectorAll('select, fieldset'));
        const currentSelections = allSelectors.map(sel => {
          if (sel.tagName === 'SELECT') {
            return sel.value;
          } else {
            const checked = sel.querySelector('input:checked');
            return checked ? checked.value : null;
          }
        });

        // Build list of matching variants
        let matchingVariants = this.variantsData.filter(v => {
          return currentSelections.every((optionValue, idx) => {
            return optionValue ? v[`option${idx + 1}`] === optionValue : true;
          });
        });

        // If current combination is unavailable, fix the changed index's partner
        const currentVariant = matchingVariants.find(v => v.available);
        if (!currentVariant) {
          // Loop through variants to find the first available one sharing the changed option
          const changedIndex = allSelectors.indexOf(changedTarget.closest('select, fieldset'));
          const availableSibling = this.variantsData.find(v => {
            return v[`option${changedIndex + 1}`] === currentSelections[changedIndex] && v.available;
          });
          if (availableSibling) {
            // Find the other selector and set it to available option
            allSelectors.forEach((sel, idx) => {
              if (idx !== changedIndex) {
                if (sel.tagName === 'SELECT') {
                  sel.value = availableSibling[`option${idx + 1}`];
                  sel.dispatchEvent(new Event('change', { bubbles: true }));
                } else {
                  const input = sel.querySelector(
                    `input[value="${availableSibling[`option${idx + 1}`]}"]`
                  );
                  if (input) {
                    input.checked = true;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
              }
            });
          }
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            ?.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
